import { http } from './../plugins/http/index';
import { getData } from './get';

// requests to API

export const postTelNumber = async (data) => http.post('/terminal/guide/send', data).then(getData);
export const postTelNumberV2 = async (data) => http.post('/terminal/guide/send-v2', data).then(getData);
export const fetchMapDataFromAPI = async (mapId) => http.get(`/map-data/${mapId}`).then(getData);
export const fetchMapDataFromLOCALHOST = async (mapId) => http.get(`maps-data/v.1.1.9/local-map-data.json`, {baseURL:''});
export const fetchMapDataFromCDN = async (mapId) => http.get(`${process.env.VUE_APP_STORAGE_BASE_URL}${process.env.VUE_APP_MAP_DATA_URL}${mapId}.json`);
export const fetchMapDataLastModified = async (mapId) => http.head(`${process.env.VUE_APP_STORAGE_BASE_URL}${process.env.VUE_APP_MAP_DATA_URL}${mapId}.json`).then(
    (response) => response && response.headers && response.headers['last-modified'] && Date.parse(response.headers['last-modified'])
);
export const getResponeStatus = async (url) => http.get(url).then((response) => response.status).catch((error) => {
    const err = {...error}
    if (err.response) return err.response.status
    return 500
})

// --------------------------  viewApi  -----------------------------------------

export const currentOrientation = () => document.viewApi.camera_controller.current_orientation
export const getPointOnFloorScreenPos = (position, unitName) =>  document.viewApi.get_point_on_floor_screen_pos(position, unitName)
export const getStepTopScreenPos = activeGuideStepIndex => document.viewApi.get_step_top_screen_pos(activeGuideStepIndex)
export const getTargetScreenPos = (target, guideStepIndex) => document.viewApi[`get_${target}_screen_pos`](guideStepIndex)
